export const removeEmpty = (object: any) => {
  if (isEmptyType(object)) return object;
  const tmpObject: any = {};
  Object.keys(object).forEach((key) => {
    if (!isEmptyType(object[key])) {
      tmpObject[key] = object[key];
    }
  });
  return tmpObject;
};